var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineMonitorSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2081_38373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2 2.60039C16.2 2.10333 15.7971 1.70037 15.3 1.70037H2.7C2.20295 1.70037 1.79998 2.10334 1.79998 2.60039V9.80038C1.79998 10.2975 2.20294 10.7004 2.7 10.7004H15.3C15.7971 10.7004 16.2 10.2975 16.2 9.80038V2.60039ZM18 9.80038C18 11.2916 16.7912 12.5004 15.3 12.5004H9.89999V14.3004H12.6C13.097 14.3004 13.5 14.7033 13.5 15.2004C13.5 15.6974 13.0971 16.1004 12.6 16.1004H5.40001C4.90295 16.1004 4.49999 15.6974 4.49999 15.2004C4.49999 14.7033 4.90295 14.3004 5.40001 14.3004H8.10001V12.5004H2.7C1.20884 12.5004 0 11.2916 0 9.80038V2.60039C0 1.10922 1.20883 -0.0996094 2.7 -0.0996094H15.3C16.7912 -0.0996094 18 1.10923 18 2.60039V9.80038Z",
    fill: "#7E7E7E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2081_38373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineMonitorSvgrepoCom1);
export default __webpack_public_path__ + "static/media/line-monitor-svgrepo-com 1.c5d2dfae43d693af92b806d61ee062fc.svg";
export { ForwardRef as ReactComponent };